import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import { checkCharacterLeft } from "../../helpers/commonHelpers";

const CloseLeadModal = (props) => {
//   const [remark, setRemark] = useState("");
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
      props.handleSubmit(reason);
      setReason("");
  };

  const closeModal = () => {
    setReason("");
    props.setIsModalOpen(false);
  };

  return (
    <>
      <Modal show={props.isModalOpen} onHide={closeModal} backdrop="static">
        <div className="modal-header">
          <h4 className="modal-title">
            {props.actionType === "close" ? "Lead Close Remark" : "Lead Reject Remark"}
          </h4>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body delete-txt">
          <h6>
            Reason
          </h6>
          <textarea
            cols="40"
            rows="4"
            id="remark"
            name="remark"
            onChange={(e) => setReason(e.target.value)}
            value={reason}
            placeholder="Enter your reason here..."
            required
          ></textarea>
          <p className="success-message">
            {checkCharacterLeft(reason)} Characters left
          </p>
        </div>

        <div className="modal-footer">
          <button type="button" onClick={handleSubmit} className="Mom-btn btn btn-secondary bg-primary border-primary">
            <p>Submit</p>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default CloseLeadModal;
